var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreaseGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 -10 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 14.5371H21V16.998H14.8066V14.5371Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 18.2285H21V20.6895H14.8066V18.2285Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 10.8457H21V13.3066H14.8066V10.8457Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44531 12.1401L2.59157 12.1311L2.53809 10.9036C7.10546 10.4584 11.2085 7.92114 13.6411 4.07174L12.162 3.38141L17.7225 0L18.7066 6.43412L16.9943 5.63563C15.8257 7.38819 13.9403 9.53552 11.2271 10.6969C8.43991 11.8895 5.45684 12.1401 3.44531 12.1401Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19336 20.6895H0V18.2285H6.19336V20.6895Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42383 14.5371H13.5762V16.998H7.42383V14.5371Z",
    fill: "#8C8C8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42383 18.2285H13.5762V20.6895H7.42383V18.2285Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseGray);
export default __webpack_public_path__ + "static/media/increase-gray.3dabfcccc62e46a84a85310161a2567b.svg";
export { ForwardRef as ReactComponent };